module.exports = "/_assets/images/branding/corval-logo-white-hex.svg";